export default __webpack_public_path__ + "static/media/apple_business.a114f6e1.png";